import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface FAQState extends BasePageState {}
interface FAQPModel {}

export default class FAQPage extends Basepage<FAQState, FAQPModel> {
  renderChild(): JSX.Element {
    return (
      <div id="FAQ">
        <b>Herzlich willkommen beim Buchbutler!</b>
        <br />
        Wir freuen uns über Ihr Interesse und beantworten Ihnen hier die
        häufigsten Fragen rund um unseren Service:
        <br />
        <hr />
        <h3>Lieferung</h3>
        <br />
        <b>Wie liefert der Buchbutler?</b>
        <ul>
          <li>
            Lieferung erfolgt ausschließlich per <b>DHL Paket, Warenpost</b>{' '}
            oder ggf.
            <b>Großbrief</b>
          </li>
          <li>
            Der Buchbutler ist <b>nicht an den Bücherwagendienst</b>{' '}
            angeschlossen
          </li>
        </ul>
        <b>Wie schnell liefert der Buchbutler?</b>
        <ul>
          <li>
            Der Buchbutler ist ein <b>Barsortiment on Demand</b>
          </li>
          <li>
            Artikel werden individuell für Sie <b>beschafft</b> und anschließend
            versendet
          </li>
          <li>
            Die <b>Lieferzeit</b> finden Sie auf der jeweiligen{' '}
            <b>Artikeldetailseite</b>
          </li>
        </ul>
        <b>Günstig vs. Schnell – was bedeutet das?</b>
        <ul>
          <li>
            <b>„Günstig“</b> = preiswerteste Bezugsquelle, ggf. längere
            Beschaffungszeit
          </li>
          <li>
            <b>„Schnell“</b> = schnellste verfügbare Quelle, ggf. höherer
            Einkaufspreis
          </li>
          <li>
            Diese Auswahl betrifft die <b>Beschaffungsart</b>, nicht die
            Versandgeschwindigkeit
          </li>
        </ul>
        <b>Was tun bei eiligen Titeln?</b>
        <ul>
          <li>
            Sobald ein Artikel bei uns eingetroffen ist, können Sie den Versand{' '}
            <b>manuell auslösen</b>
          </li>
          <li>
            Gehen Sie dazu in Ihrem Kundenkonto zum Menüpunkt{' '}
            <b>„Bereit zum Versand“</b>
          </li>
        </ul>
        <hr />
        <h3>Versandkosten & Rechnung</h3>
        <b>Welche Portokosten fallen an?</b>
        <ul>
          <li>
            Portokosten innerhalb Deutschlands:{' '}
            <a href="/versandkosten" target="_blank">
              PORTO
            </a>
          </li>
          <li>
            Für internationale Sendungen:{' '}
            <a href="/versandkosten_all" target="_blank">
              Shipping Costs
            </a>
          </li>
          <li>
            <b>Handlingskosten</b> in Höhe von <b>0,75 €</b> kommen zu jeder
            Sendung hinzu. Die Verpackungskosten sind bereits enthalten.
            <br />
            Ab dem 1. Januar 2027 betragen die Handlingskosten <b>0,92 €</b> je
            Sendung.
          </li>
        </ul>
        <b>Warum wird eine separate Rechnung für Versandkosten erstellt?</b>
        <ul>
          <li>
            Die Versandkosten werden <b>transparent und separat</b> berechnet
          </li>
          <li>
            So sehen Sie auf einen Blick, welche Kosten für die Artikel und
            welche für den Versand anfallen
          </li>
        </ul>
        <b>Wie kann ich Portokosten sparen?</b>
        <ul>
          <li>
            Legen Sie bitte in Ihrem <b>Kundenkonto</b> einen <b>Versandtag</b>{' '}
            fest
          </li>
          <li>
            Wir sammeln Ihre Bestellungen für Sie und versenden sie an dem von
            Ihnen gewählten Versandtag. So fallen <b>nur einmal Portokosten</b>{' '}
            an.
          </li>
        </ul>
        <hr />
        <h3>Zahlung</h3>
        <b>Wie kann ich den Buchbutler bezahlen?</b>
        <ul>
          <li>Aktuell verfügbare Zahlarten:</li>
          <ul>
            <li>
              <b>Rechnung</b>
            </li>
            <li>
              <b>Abrechnung über die BAG</b>
            </li>
          </ul>
          <li>
            Die Auswahl erfolgt im <b>Bestellprozess</b>
          </li>
        </ul>
        <hr />
        <h3>Preise & Konditionen</h3>
        <b>Wie teuer ist der Buchbutler?</b>
        <ul>
          <li>
            Es gibt <b>keine pauschalen Konditionen</b>
          </li>
          <li>
            <b>Einkaufspreis</b>, <b>Rabatt</b> und <b>Lieferzeit</b> sind je
            Artikel auf der <b>Detailseite</b> einsehbar
          </li>
        </ul>
        <b>Kann ich einen höheren Rabatt bekommen?</b>
        <ul>
          <li>
            <b>Nein</b>, alle Buchhändler erhalten{' '}
            <b>die gleichen Konditionen</b>, unabhängig vom Umsatz
          </li>
          <li>
            Das sorgt für <b>Fairness</b> und <b>Transparenz</b>
          </li>
        </ul>
        <hr />
        <h3>Kundenkonto & Registrierung</h3>
        <b>Muss ich mich registrieren?</b>
        <ul>
          <li>
            Ja, bei Ihrer <b>ersten Bestellung</b> wird automatisch ein{' '}
            <b>Kundenkonto</b> erstellt
          </li>
          <li>
            Eine <b>Bestellung als Gast</b> ist <b>nicht möglich</b>
          </li>
        </ul>
        <b>Was finde ich in meinem Kundenkonto?</b>
        <ul>
          <li>
            Ihre <b>Kundennummer</b>
          </li>
          <li>
            Möglichkeit, standardmäßig eine <b>Bezugsvariante</b> für Ihre
            Bestellungen auszuwählen (Diese Auswahl betrifft die
            Beschaffungsart, nicht die Versandgeschwindigkeit)
          </li>
          <li>
            Möglichkeit, einen <b>Versandtag</b> auszuwählen. Wenn keine Auswahl
            getroffen wird, ist der Versand an allen Tagen vorgesehen. Für die
            Festlegung eines Versandtags wählen Sie bitte die anderen Tage ab.
          </li>
          <li>
            <b>Adressverwaltung</b> (Liefer- & Rechnungsadressen)
          </li>
          <li>
            Übersicht aller <b>Bestellungen</b> mit Einkaufspreis,
            Verkaufspreis, Rabatt und MwSt.
          </li>
          <li>
            Übersicht aller <b>Lieferungen</b> mit Sendungsnummern und
            Informationen, welche Artikel sich in welchem Paket befinden
          </li>
          <li>
            <b>Offene Positionen</b>, die noch nicht versendet wurden – diese
            können unter <b>„Storno anfragen“</b> storniert werden
          </li>
          <li>
            <b>Bereit zum Versand</b> – Titel, die bereits bei uns sind, sollte
            es eilig sein, können Sie dort den Versand auslösen.
          </li>
          <li>
            Zugriff auf alle Ihre <b>Rechnungen</b> zum <b>Download</b>
          </li>
          <li>
            Übersicht über geleistete <b>Zahlungen</b>
          </li>
        </ul>
        <hr />
        <h3>Rechnungen & Steuern</h3>
        <b>Wie erhalte ich meine Rechnungen?</b>
        <ul>
          <li>
            Ihre Rechnung erhalten Sie <b>automatisch per E-Mail</b> am Abend
            des Versandtages
          </li>
        </ul>
        <b>Wie werden Steuern ausgewiesen?</b>
        <ul>
          <li>
            Bei Lieferungen nach <b>Deutschland: inkl. ausgewiesener MwSt</b>.
          </li>
          <li>
            Innerhalb der{' '}
            <b>EU: steuerfreie innergemeinschaftliche Lieferung</b> bei gültiger{' '}
            <b>USt-ID</b>
          </li>
        </ul>
        <hr />
        <h3>Retouren & Reklamationen</h3>
        <b>Habe ich ein Retouren- oder Remissionsrecht?</b>
        <ul>
          <li>
            Ja, bitte nehmen Sie vorab Kontakt mit unserem <b>Kundenservice</b>{' '}
            auf:
            <br />
            <br />
            <b>retoure@Buchbutler.de</b>
            <br />
            <br />
            <b>
              Genehmigte Retouren senden Sie bitte ausreichend frankiert an:
            </b>
            <br />
            <br />
            Moluna GmbH – Buchbutler Retoure
            <br />
            Engberdingdamm 27
            <br />
            48268 Greven
          </li>
        </ul>
        <b>Kosten für Retourenbearbeitung:</b>
        <ul>
          <li>
            <b>3 % Bearbeitungsgebühr</b>
          </li>
          <li>
            <b>0,50 € Widereinlagerungspauschale pro Exemplar</b>
          </li>
          <li>
            Diese Kosten entfallen selbstverständlich bei einer{' '}
            <b>Defekt- oder Falschlieferung</b>. Nehmen Sie bitte auch in diesem
            Fall Kontakt mit unserem Kundenservice auf.
          </li>
        </ul>
        <hr />
        <h3>Technik & Integration</h3>
        <b>
          Kann der Buchbutler per Dropshipping direkt an meine Kunden liefern?
        </b>
        <ul>
          <li>
            <b>Ja</b>, Dropshipping wird angeboten – inkl. passender
            Schnittstellen
          </li>
          <li>
            Bitte kontaktieren Sie unseren <b>Kundenservice</b> per E-Mail
          </li>
        </ul>
        <b>
          Bietet der Buchbutler Datenschnittstellen für Shopsysteme oder
          Warenwirtschaft?
        </b>
        <ul>
          <li>
            <b>Ja</b> entsprechende Schnittstellen sind verfügbar
          </li>
          <li>
            Auch hier bitten wir um <b>Kontaktaufnahme per E-Mail</b>
          </li>
        </ul>
        <hr />
        <h3>Noch Fragen?</h3>
        <ul>
          <li>
            Unser Kundenservice hilft Ihnen gerne weiter: <br />
            <b>02571 / 8 07 28 80</b> <br />
            <b>info@Buchbutler.de</b>
          </li>
        </ul>
      </div>
    );
  }
  initState(base: BasePageState): FAQState {
    let newState: FAQState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'FAQ';
  }
  getBreadCrumb(): JSX.Element {
    return <span>FAQ</span>;
  }
  getType(): string {
    return 'FAQPage';
  }
}
